/* One light colour per role, stable across pages and sessions.
   Used by the users table, the user drawer and the roles table. */

const ROLE_TONES = ['indigo', 'teal', 'amber', 'rose', 'violet', 'sky', 'emerald'];

export function roleTone(roleName) {
  if (!roleName) return 'slate';
  const key = String(roleName).toLowerCase();
  if (key.includes('ex-') || key.includes('former') || key.includes('inactive')) return 'slate';
  if (key.includes('admin') || key.includes('owner') || key.includes('super')) return 'violet';

  let hash = 0;
  for (let i = 0; i < key.length; i += 1) hash = (hash * 31 + key.charCodeAt(i)) % 9973;
  return ROLE_TONES[hash % ROLE_TONES.length];
}

export default roleTone;
